import { Button,  Link, Menu, MenuItem} from "@mui/material";
import { useEffect, useRef, useState } from "react";

import EditProfileDialog from "./EditProfileDialog";
import { req } from "./ServerUtils";
import { HelpDialog } from "./HelpDialog";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { useUser } from "./UserProvider";
import { BrandDialog } from "./BrandDialog";
import { useNavigate } from "react-router-dom";
import InfoIcon from '@mui/icons-material/Info';
const PLACEHOLDER_PROFILE_PIC = "/images/placeholder-profilepic.jpg";

export function NavBar({children}) {
  const {userInfo, setUserInfo} = useUser();
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm')); // Returns true for small screens
  
  
  return (
    <div
      className="navbar"
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 5,
        justifyContent: "space-between",
        alignItems: "center",
        padding: 8,

        background: "linear-gradient(33deg, #9C27B0 30%, #673AB7 60%)",
        color: "white",
      }}
    >
      <div>
        
        <div style={{
            display: "flex",
            flexDirection: "row",
            gap: "1rem",
            alignItems: "center",
            justifyContent: "center",
        }}>
          <img
            src="/images/logo.svg"
            alt="Make My Brand"
            style={{
                width: "3rem",
                height: "3rem",
                color: "purple"
            }}
          />
          {!smallScreen && (
            <div className="brand">
              <a
                style={{
                  color: "white"
                }}
                href="/"
              >
                MakeMyBrand
              </a>
            </div>
          )}
          <span>•</span>
          {
            userInfo?.subscription_type == "free-trial" && (
              <>
              <Link
                variant="link"
                href={'/choose-plan'}
                style={{
                  textTransform: "none",
                  color: "white",
                  textDecoration: "underline !important"
                }}
              >
                Plans
              </Link>
              <span>•</span>
              </>
            ) 
          }
          
          
            <Link
              variant="link"
              href={'/how-makemybrand-works'}
              style={{
                textTransform: "none",
                color: "white",
                textDecoration: "underline !important",
                display: "flex"
              }}
            >
              {smallScreen ? <InfoIcon /> :  "How does this work?" }
            </Link>
            
      </div>
    </div>
    
      
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: 20,
          justifyContent: "space-between",
          alignItems: "center",

          background: "transparent",
        }}
      >

        {!smallScreen && (
        <Button variant="outlined"
            onClick={() => {
              window.open('https://chromewebstore.google.com/detail/linkedin-carousel-generat/epehcmcofkloohohfibbjdghiefhegfg', '_blank');
            }}
            style={{
                textTransform: "none",
                borderColor: "white",
                color: "white",

            }}
          >
          <img src="/images/chrome.webp" alt="Chrome" style={{ width: "1rem", height: "1rem", marginRight: "0.5rem" }} />
          Create Carousels directly from LinkedIn
        </Button>
        )}

        {children}

        <ProfilePic userInfo={userInfo} setUserInfo={setUserInfo} smallScreen={smallScreen}/>

        {!userInfo && (
          <Link
            underline="none"
            variant="button"
            href={'/login'}
            style={{
              textTransform: "none",
              color: "white",
              textDecoration: "underline !important"
            }}
          >
            Login
          </Link>
        )}
      </div>
    </div>
  );
}

function ProfilePic({ userInfo, setUserInfo, smallScreen }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [showDialog, setShowDialog] = useState(null);
  const fileRef = useRef(null);
  const [src, setSrc] = useState(userInfo?.info?.profile_pic_cropped || PLACEHOLDER_PROFILE_PIC);
  const [showEditProfileDialog, setShowEditProfileDialog] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showBrandDialog, setShowBrandDialog] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!userInfo?.info?.profile_pic_cropped) {
      setSrc(PLACEHOLDER_PROFILE_PIC);
      return;
    }
    fetch(userInfo?.info?.profile_pic_cropped + "?t=" + new Date().getTime())
      .then((res) => {
        if (res.status === 404) {
          setSrc(PLACEHOLDER_PROFILE_PIC);
        } else {
          setSrc(userInfo?.info?.profile_pic_cropped + "?t=" + new Date().getTime());
        }
      })
      .catch((e) => {
        setSrc(PLACEHOLDER_PROFILE_PIC);
        console.error(e);
      });
  }, [userInfo]);

  function verifyAndUpload(key, file, api) {
    if (!file.type.startsWith("image/")) {
      console.error("File is not an image.");
      return Promise.reject("File is not an image.");
    }
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          const formData = new FormData();
          formData.append(key, file);

          api(formData)
            .then((res) => {
              if (res.error) {
                reject(res.error);
              } else {
                resolve(res);
              }
            })
            .catch((e) => reject(e));
        };
        img.src = event.target.result;
      };

      reader.readAsDataURL(file);
    });
  }

  function onFileUpload(e) {
    verifyAndUpload("profile_pic_uncropped", e.target.files[0], (formData) => {
      return req("/upload_profile_pic", "POST", formData, false);
    })
      .then((res) => {
        userInfo.profile_pic_cropped = res.profile_pic_url;
        setUserInfo({ ...userInfo });
      })
      .catch((e) => {
        console.error(e);
      });
    fileRef.current.value = ""; // Without this, clicking it 2nd time doesn't work
  }

  function onCropComplete(blob) {
    const formData = new FormData();
    formData.append("profile_pic_cropped", blob, "cropped-image.png");
    req("/upload_profile_pic", "POST", formData, false)
      .then((res) => {
        userInfo.profile_pic_cropped = res.profile_pic_url;
        setUserInfo({ ...userInfo });
      })
      .catch((error) => console.error(error));
  }

  return (
    <>
      
      
      <div
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
        }}
      >
        <img
          src={src}
          alt="Profile"
          style={{
            height: "30px",
            borderRadius: "50%",
            cursor: "pointer",
          }}
        />
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => {
          setAnchorEl(null);
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disablePortal={true}
      >
        <MenuItem
          onClick={() => {
            setShowEditProfileDialog("profile");
            setAnchorEl(null);
          }}
        >
          My Profile
        </MenuItem>
        <MenuItem
          onClick={() => {
            setShowBrandDialog(true);
            setAnchorEl(null);
          }}
        >
          My Brand
        </MenuItem>
        <MenuItem
          onClick={() => {
            setShowEditProfileDialog("tokens");
            setAnchorEl(null);
          }}
        >
          My Tokens
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setShowHelp(true);
          }}
        >
          Help
        </MenuItem>
        <MenuItem
          onClick={() => {
            req("/logout", "POST", {}).then(() => {
              navigate('/login');
            });
            setAnchorEl(null);
          }}
        >
          Logout
        </MenuItem>
      </Menu>

      <input style={{ display: "none" }} ref={fileRef} type="file" accept="image/*" onChange={(e) => onFileUpload(e)} />

      <EditProfileDialog smallScreen={smallScreen} userInfo={userInfo} setUserInfo={setUserInfo} dialog={showEditProfileDialog} onClose={() => setShowEditProfileDialog(false)} onSave={(data) => console.log(data)} user={userInfo} setDialog={setShowEditProfileDialog}/>
      <HelpDialog userInfo={userInfo} setUserInfo={setUserInfo} showHelp={showHelp} setShowHelp={setShowHelp} />
      <BrandDialog userInfo={userInfo} setUserInfo={setUserInfo} showBrandDialog={showBrandDialog} setShowBrandDialog={setShowBrandDialog} />
    </>
  );
}
